module.exports = "/fonts/fa-solid-900.woff2?61f505c6569bacdd2b629dfd332a2cef";